import React, { Component } from "react";
import Product from "./components/product";
import HandHover from "./components/handHover";
import { getDashboardData } from "../services/dashboardServices";
import { connect } from "react-redux";
import Layout from "./components/Layout";
import Skeleton from 'react-loading-skeleton';




class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      dashboardData: [],
      updateDashboardData: [],
      team: "compliance",
      showModal: false,
      dataLoaded: false,


    };
  }
  componentDidMount() {
    getDashboardData().then((json) => {
      this.setState({
        dashboardData: json,
        dataLoaded: true,
      });
    });
  }

  handleShow = () => {
    this.setState({ showModal: true });
  }

  handleClose = () => {
    this.setState({ showModal: false });
  }

  render() {
    
    const {dashboardData, dataLoaded} = this.state;
    const { compliance_gsos, compliance } = { ...this.props?.posts[0] };


    return (
      <>
      <section className="dashboard">
        <Layout team="compliance">
              {this.state.team !== "handHover" ? (
                <div className="main-pannel white-gradient">
          <div className="xdr-nav">
            <div className="xdr-info">
              {/* <img src="images/invinsense_XDR_logo1.png" id="xdr-logo-1"/> */}
              {/* <img src="images/invinsense_XDR_logo2.png" id="xdr-logo-2"/> */}
              {/* <img src="images/invinsense_XDR_logo3.png" id="xdr-logo-3"/> */}
              <img alt="invinsense XDR" src="images/invinsense_XDR_logo4.png" />
              {/* <p id="xdr-para-1">The Defender's Brain of <br />your cybersecurity</p> */}
              {/* <p id="xdr-para-2">The Attacker's Mind of your<br />cybersecurity</p> */}
              {/* <p id="xdr-para-3">Improve your Detection and <br />Response with Attacker's Actions</p> */}
              <p>An intutive platform for Governance,<br />Risk and Compliance</p>
            </div>
            { !this.state.showModal && <div className="xdr-architecture xdr-cursor" onClick={this.handleShow}>
              <div className="xdr-arc-icon">
                <img src="images/flow.png" />
              </div>
              <p>View Architecture</p>
            </div>}
            {this.state.showModal && <div className="xdr-architecture close xdr-cursor" onClick={this.handleClose}>
              <div className="xdr-arc-icon">
              <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000"><path d="M0 0h24v24H0z" fill="none"/><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>
              </div>
              <p>Close</p>
            </div>}

            {/* { this.state.showModal && <div className="xdr-architecture close xdr-cursor" onClick={this.handleClose}>
              <div className="xdr-arc-icon">
              <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000"><path d="M0 0h24v24H0z" fill="none"/><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>
              </div>
              <p>Close</p>
            </div>} */}
            
          </div>


          { this.state.showModal && <div className="justify-content-center d-flex"><img className="diagramImg" src="diagrams/Diagram_GSOS.png" alt="Invinsense GSOS: An Intuitive Platform for Governance, Risk, and Compliance"/></div>}
          <div className="w-layout-grid card-row-1" style={{transform: 'translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)', transformStyle: "preserve-3d", opacity: "1", display: "grid"}}   id="xdr-row-1">


          {  !this.state.showModal && (dataLoaded ? dashboardData?.map((prod) => {
                        if(prod.gname === 'compliance'){
                          return <Product color='pinkBack' product={prod} />;
                          }
                      }): <div>
              <Skeleton height={273} borderRadius={"24px"}/> 
            </div>)}


{/* { !this.state.showModal && data.products?.map((prod) => {
              let product = this.state?.dashboardData?.filter(
                (dd, i) => {
                  return dd.g_sub_name === prod.g_sub_name;
                }
              );
              if (product.length > 0) {
                prod.link = product[0].link;
              }

              if(pink_gsos === true && prod.g_sub_name === "pink_gsos"){

              return <Product color='pinkBack' product={prod} />;}

              if(pink === true){
                return <Product color='pinkBack' product={prod} />;
              }
            })} */}
          </div>  
          


          {/* {!this.state.showModal && <div className="coming-soon">
            <img src="images/comin-soon.png" />
          </div>} */}
        </div>
              ) : (
                <HandHover />
              )}
              </Layout>
        </section>

        {/* <Modal show={this.state.showModal} onHide={this.handleClose} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title><div className="xdr-info">
              <img src="images/invinsense_XDR_logo4.png" />
              <p >An intutive platform for Governance,<br />Risk and Compliance</p>
            </div></Modal.Title>
        </Modal.Header>
        <Modal.Body>        <img src="diagrams/Diagram_GSOS.png" alt="Invinsense GSOS: An Intuitive Platform for Governance, Risk, and Compliance"/>
</Modal.Body>
        
      </Modal> */}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return { posts: state.posts };
};

export default connect(mapStateToProps)(Dashboard);
